const getAtomBetType = (val) => {
  switch(val){
    case "MAIN_BIG": return "Tài";
    case "MAIN_SMALL": return "Xỉu";
    case "MAIN_ODD": return "Lẻ";
    case "MAIN_EVEN": return "Chẵn";
    case "MAIN_RED": return "Đỏ";
    case "MAIN_BLACK": return "Đen";
    case "MAIN_HIGH": return "Cao";
    case "MAIN_LOW": return "Thấp";
    case "MAIN_SPRING": return "Xuân";
    case "MAIN_SUMMER": return "Hạ";
    case "MAIN_AUTUMN": return "Thu";
    case "MAIN_WINTER": return "Đông";
    case "L1_BIG": return "Dòng 1 Tài";
    case "L1_SMALL": return "Dòng 1 Xỉu";
    case "L1_ODD": return "Dòng 1 Lẻ";
    case "L1_EVEN": return "Dòng 1 Chẵn";
    case "L1_RED": return "Dòng 1 Đỏ";
    case "L1_BLACK": return "Dòng 1 Đen";
    case "L1_HIGH": return "Dòng 1 Cao";
    case "L1_LOW": return "Dòng 1 Thấp";
    case "L2_BIG": return "Dòng 2 Tài";
    case "L2_SMALL": return "Dòng 2 Xỉu";
    case "L2_ODD": return "Dòng 2 Lẻ";
    case "L2_EVEN": return "Dòng 2 Chẵn";
    case "L2_RED": return "Dòng 2 Đỏ";
    case "L2_BLACK": return "Dòng 2 Đen";
    case "L2_HIGH": return "Dòng 2 Cao";
    case "L2_LOW": return "Dòng 2 Thấp";
    case "L3_BIG": return "Dòng 3 Tài";
    case "L3_SMALL": return "Dòng 3 Xỉu";
    case "L3_ODD": return "Dòng 3 Lẻ";
    case "L3_EVEN": return "Dòng 3 Chẵn";
    case "L3_RED": return "Dòng 3 Đỏ";
    case "L3_BLACK": return "Dòng 3 Đen";
    case "L3_HIGH": return "Dòng 3 Cao";
    case "L3_LOW": return "Dòng 3 Thấp";
    case "L4_BIG": return "Dòng 4 Tài";
    case "L4_SMALL": return "Dòng 4 Xỉu";
    case "L4_ODD": return "Dòng 4 Lẻ";
    case "L4_EVEN": return "Dòng 4 Chẵn";
    case "L4_RED": return "Dòng 4 Đỏ";
    case "L4_BLACK": return "Dòng 4 Đen";
    case "L4_HIGH": return "Dòng 4 Cao";
    case "L4_LOW": return "Dòng 4 Thấp";
    case "L5_BIG": return "Dòng 5 Tài";
    case "L5_SMALL": return "Dòng 5 Xỉu";
    case "L5_ODD": return "Dòng 5 Lẻ";
    case "L5_EVEN": return "Dòng 5 Chẵn";
    case "L5_RED": return "Dòng 5 Đỏ";
    case "L5_BLACK": return "Dòng 5 Đen";
    case "L5_HIGH": return "Dòng 5 Cao";
    case "L5_LOW": return "Dòng 5 Thấp";
    default: return val;
  }
}

const getAtomWarBetType = (val) => {
  switch(val){
    case "MAIN_PLAYER": return "Người chơi";
    case "MAIN_BANKER": return "Nhà cái";
    case "MAIN_TIE": return "Hoà";
    case "MAIN_BIG": return "Tài";
    case "MAIN_SMALL": return "Xỉu";
    case "MAIN_ODD": return "Lẻ";
    case "MAIN_EVEN": return "Chẵn";
    case "MAIN_RED": return "Đỏ";
    case "MAIN_BLACK": return "Đen";
    case "MAIN_R_B": return "/";
    case "MAIN_HIGH": return "Cao";
    case "MAIN_LOW": return "Thấp";
    case "MAIN_H_L": return "/";
    case "PLAYER_BIG": return "Người chơi Tài";
    case "PLAYER_SMALL": return "Người chơi Xỉu";
    case "PLAYER_ODD": return "Người chơi Lẻ";
    case "PLAYER_EVEN": return "Người chơi Chẵn";
    case "PLAYER_RED": return "Người chơi Đỏ";
    case "PLAYER_BLACK": return "Người chơi Đen";
    case "PLAYER_HIGH": return "Người chơi Cao";
    case "PLAYER_LOW": return "Người chơi Thấp";
    case "BANKER_BIG": return "Nhà cái Tài";
    case "BANKER_SMALL": return "Nhà cái Xỉu";
    case "BANKER_ODD": return "Nhà cái Lẻ";
    case "BANKER_EVEN": return "Nhà cái Chẵn";
    case "BANKER_RED": return "Nhà cái Đỏ";
    case "BANKER_BLACK": return "Nhà cái Đen";
    case "BANKER_HIGH": return "Nhà cái Cao";
    case "BANKER_LOW": return "Nhà cái Thấp";
    default: return val;
  }
}

export const getBetTypeValue = (game, val) => {
  // console.log('getBetTypeValue', game, val);
  switch(game){
    case "atom":
      return getAtomBetType(val);
    case "atom_war":
      return getAtomWarBetType(val);
    default:
      return val;
  }
}

const getAtomBetTypeGroup = (val) => {
  switch(val){
    case "MAIN_BIG":
    case "MAIN_SMALL": return "Tài/Xỉu";
    case "MAIN_ODD":
    case "MAIN_EVEN": return "Chẵn/Lẻ";
    case "MAIN_RED":
    case "MAIN_BLACK": return "Đỏ/Đen";
    case "MAIN_HIGH":
    case "MAIN_LOW": return "Cao/Thấp";
    case "MAIN_SPRING":
    case "MAIN_SUMMER":
    case "MAIN_AUTUMN":
    case "MAIN_WINTER": return "Xuân/Hạ/Thu/Đông";
    case "L1_BIG":
    case "L1_SMALL": return "Dòng 1 Tài/Xỉu";
    case "L1_ODD":
    case "L1_EVEN": return "Dòng 1 Chẵn/Lẻ";
    case "L1_RED":
    case "L1_BLACK": return "Dòng 1 Đỏ/Đen";
    case "L1_HIGH":
    case "L1_LOW": return "Dòng 1 Cao/Thấp";
    case "L2_BIG":
    case "L2_SMALL": return "Dòng 2 Tài/Xỉu";
    case "L2_ODD":
    case "L2_EVEN": return "Dòng 2 Chẵn/Lẻ";
    case "L2_RED":
    case "L2_BLACK": return "Dòng 2 Đỏ/Đen";
    case "L2_HIGH":
    case "L2_LOW": return "Dòng 2 Cao/Thấp";
    case "L3_BIG":
    case "L3_SMALL": return "Dòng 3 Tài/Xỉu";
    case "L3_ODD":
    case "L3_EVEN": return "Dòng 3 Chẵn/Lẻ";
    case "L3_RED":
    case "L3_BLACK": return "Dòng 3 Đỏ/Đen";
    case "L3_HIGH":
    case "L3_LOW": return "Dòng 3 Cao/Thấp";
    case "L4_BIG":
    case "L4_SMALL": return "Dòng 4 Tài/Xỉu";
    case "L4_ODD":
    case "L4_EVEN": return "Dòng 4 Chẵn/Lẻ";
    case "L4_RED":
    case "L4_BLACK": return "Dòng 4 Đỏ/Đen";
    case "L4_HIGH":
    case "L4_LOW": return "Dòng 4 Cao/Thấp";
    case "L5_BIG":
    case "L5_SMALL": return "Dòng 5 Tài/Xỉu";
    case "L5_ODD":
    case "L5_EVEN": return "Dòng 5 Chẵn/Lẻ";
    case "L5_RED":
    case "L5_BLACK": return "Dòng 5 Đỏ/Đen";
    case "L5_HIGH":
    case "L5_LOW": return "Dòng 5 Cao/Thấp";
    default: return val;
  }
}

const getAtomWarBetTypeGroup = (val) => {
  switch(val){
    case "MAIN_PLAYER":
    case "MAIN_BANKER":
    case "MAIN_TIE": return "Người chơi/Hoà/Nhà cái";
    case "MAIN_BIG":
    case "MAIN_SMALL": return "Tổng Tài/Xỉu";
    case "MAIN_ODD":
    case "MAIN_EVEN": return "Tổng Chẵn/Lẻ";
    case "MAIN_R_B":
    case "MAIN_RED": 
    case "MAIN_BLACK": return "Tổng Đỏ/Đen";
    case "MAIN_H_L":
    case "MAIN_HIGH":
    case "MAIN_LOW": return "Tổng Cao/ Thấp";
    case "PLAYER_BIG":
    case "PLAYER_SMALL": return "Người chơi Tài/Xỉu";
    case "PLAYER_ODD":
    case "PLAYER_EVEN": return "Người chơi Chẵn/Lẻ";
    case "PLAYER_RED":
    case "PLAYER_BLACK": return "Người chơi Đỏ/Đen";
    case "PLAYER_HIGH":
    case "PLAYER_LOW": return "Người chơi Cao/Thấp";
    case "BANKER_BIG":
    case "BANKER_SMALL": return "Nhà cái Tài/Xỉu";
    case "BANKER_ODD":
    case "BANKER_EVEN": return "Nhà cái Chẵn/Lẻ";
    case "BANKER_RED":
    case "BANKER_BLACK": return "Nhà cái Đỏ/Đen";
    case "BANKER_HIGH": 
    case "BANKER_LOW": return "Nhà cái Cao/Thấp";
    default: return val;
  }
}
export const getBetTypeGroupValue = (game, val) => {
  // console.log('getBetTypeGroup', game, val);
  switch(game){
    case "atom":
      return getAtomBetTypeGroup(val);
    case "atom_war":
      return getAtomWarBetTypeGroup(val);
    default:
      return val;
  }
}